import PropTypes from 'prop-types'

import styles from './LoyaltyTooltip.module.scss'
function toPascalCase(str) {
  if (str) {
    return str.toLowerCase().replace(/\b(\w)/g, function (_, firstChar) {
      return firstChar.toUpperCase()
    })
  }
  return str
}

const LoyaltyTooltip = ({ loyaltyLevel, loyaltyProgram, customText }) => {
  let program =
    loyaltyProgram && loyaltyProgram.match(/(GP|CN|CE|MC|AU)/i)
      ? 'Choice privilages member'
      : null
  let loyalty = loyaltyLevel ? toPascalCase(loyaltyLevel) : null
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        {program && <p className={styles.title}>{program}</p>}
        {customText && <p className={styles.title}>{customText}</p>}
        {loyalty && <p className={styles.no}>{loyalty}</p>}
      </div>
    </div>
  )
}

LoyaltyTooltip.prototypes = {
  loyaltyLevel: PropTypes.string,
  loyaltyProgram: PropTypes.string,
  loyaltyId: PropTypes.string
}

export default LoyaltyTooltip
